import React from 'react';
import type { WorklistCounts } from '../../api/laneApi';
import { WORKLIST_CHIPS, WorklistChoice, chipCount } from './worklists';
import './lanes.css';

export interface WorklistChipsProps {
  value: WorklistChoice;
  /** `undefined` until (or unless) the server sends counts: names only, no numbers. */
  counts: WorklistCounts | undefined;
  onChange: (choice: WorklistChoice) => void;
}

/** The Lender task lists as chips with counts (spec §4.12, R17). */
export const WorklistChips: React.FC<WorklistChipsProps> = ({ value, counts, onChange }) => (
  <div className="lender-worklists" role="group" aria-label="Lists">
    {WORKLIST_CHIPS.map(({ key, label }) => {
      const count = chipCount(counts, key);
      const chosen = value === key;
      return (
        <button
          key={key}
          type="button"
          className={`lender-worklists__chip${chosen ? ' lender-worklists__chip--active' : ''}`}
          aria-pressed={chosen}
          onClick={() => { if (!chosen) onChange(key); }}
        >
          {label}
          {count !== undefined && (
            <>
              {' '}
              <span className="lender-worklists__count">{count.toLocaleString()}</span>
            </>
          )}
        </button>
      );
    })}
  </div>
);

export default WorklistChips;
